export const app = {
  ENV_VAR_PREFIX: 'APP_NAME_',
};

export const localStorageKeys = {
  AMA_CLIENTS_GRID_STATE: 'amaClientsGridState',
  AMA_SNAPSHOTS_GRID_STATE: 'amaSnapshotsGridState'
};

export const urlParams = { 
  ID: 'id',
  AMA_GRID_FILTER: 'f',
  // Deep link params for snapshots
  CLIENT_ID: 'cid',
  ACADEMIC_YEAR: 'ay',
  SNAPSHOT_DATE: 'sd',
  OPERATION: 'op',
  TAB: 'tab'
};

export const operation = {
  INGEST: 'ingest',
  VALIDATE: 'validate',
  APPROVE: 'approve',
  SUBMIT: 'submit'
};

export const logLevel = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  DEBUG: 'debug'
};